import { Image, Skeleton } from '@round/ui-kit';
import { Tooltip } from '@round/whitelabel-ui';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { TableCellContext, getTableMeta } from '../helpers';
import styles from './OwnedByCell.module.css';

const OwnedByCell = ({ row: { original }, table }: TableCellContext<'owned_by'>) => {
    const { getIsRowLoading, isPartnershipLoading } = getTableMeta(table);
    const { selectedClient } = useClientSelect();

    if (getIsRowLoading(original) || isPartnershipLoading?.(original)) {
        return <Skeleton circle width="1.5rem" height="1.5rem" />;
    }

    const owner =
        original.owned_by === null
            ? selectedClient && { name: selectedClient.name, logo: selectedClient.logo }
            : original.partnership && {
                  name: original.partnership.agency_name,
                  logo: original.partnership.agency_logo,
              };

    if (!owner) {
        return <>-</>;
    }

    return (
        <Tooltip.Root>
            {(anchor, setAnchor) => (
                <>
                    <span ref={setAnchor} className={styles.container} aria-label={owner.name}>
                        <Image className={styles.logo} src={owner.logo ?? ''} alt={owner.name} />
                    </span>
                    <Tooltip anchorElement={anchor}>
                        <Tooltip.Body>{owner.name}</Tooltip.Body>
                    </Tooltip>
                </>
            )}
        </Tooltip.Root>
    );
};

export default OwnedByCell;
